<script setup>
import {computed} from 'vue'
import PreviousConferenceStatCard from '@/components/previous-conference/PreviousConferenceStatCard'

const props = defineProps({
    previousConference: {
        type: Object,
        required: true,
    },
})

/**
 * Input example: rawValue = 4, label = "Keynote Speakers", icon = "mic"
 * Output example: { value: 4, label: "Keynote Speakers", icon: "mic" }
 */
function createProgramStat(rawValue, label, icon) {
    if (rawValue === null || typeof rawValue === 'undefined') {
        return null
    }

    return {
        value: rawValue,
        label,
        icon,
    }
}

const programStats = computed(() => {
    return [
        createProgramStat(props.previousConference.number_of_keynotes, 'Keynote Speakers', 'mic'),
        createProgramStat(props.previousConference.number_of_perspective_talks, 'Perspective Talks', 'spark'),
        createProgramStat(props.previousConference.number_of_contributed_talks, 'Contributed Talks', 'message'),
        createProgramStat(props.previousConference.number_of_workshops, 'Workshops', 'users'),
        createProgramStat(props.previousConference.number_of_panel_experts, 'Panel Experts', 'panel'),
    ].filter(Boolean)
})
</script>

<template>
    <section v-if="programStats.length > 0" class="space-y-5">
        <div>
            <h2 class="font-heading text-2xl font-semibold text-slate-900">Scientific Program at a Glance</h2>
            <div class="mt-3 h-1 w-16 bg-teal-700"></div>
        </div>

        <div class="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
            <PreviousConferenceStatCard
                v-for="stat in programStats"
                :key="stat.label"
                :value="stat.value"
                :label="stat.label"
                :icon="stat.icon" />
        </div>
    </section>
</template>

<style scoped></style>
